import { Instagram as IgIcon, Facebook as FbIcon, MessageCircle } from "lucide-react";
import { BRAND, waLink } from "../../lib/brand";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-zinc-950 text-zinc-300"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-20 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-4">
            <div className="h-14 w-14 bg-white grid place-items-center border border-white/30 p-1">
              <img
                src={BRAND.logoUrl}
                alt="GR"
                className="h-full w-full object-contain"
              />
            </div>
            <div>
              <div className="font-display text-xl text-white leading-tight">
                Ghisa Ram Khandelwal
              </div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mt-1">
                Saraf · Since 1972 · Delhi
              </div>
            </div>
          </div>
          <p className="mt-6 max-w-md text-zinc-400 leading-relaxed">
            A traditional silver jeweller in Chandni Chowk, Delhi — serving
            Indian families with pure 92.5 silver since 1972. Hand-finished,
            heirloom-worthy pieces.
          </p>
        </div>

        <div className="lg:col-span-3">
          <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-5">
            Explore
          </div>
          <ul className="space-y-3 text-sm">
            {[
              ["#collections", "Collections"],
              ["#legacy", "Legacy"],
              ["#craftsmanship", "Craftsmanship"],
              ["#instagram", "Instagram"],
              ["#contact", "Contact"],
            ].map(([href, label]) => (
              <li key={href}>
                <a
                  href={href}
                  data-testid={`footer-${label.toLowerCase()}`}
                  className="text-zinc-300 hover:text-white transition-colors"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-5">
            Reach Us
          </div>
          <p className="text-sm text-zinc-300 leading-relaxed">
            {BRAND.address}
          </p>
          <p className="mt-3 text-sm text-zinc-400">{BRAND.phoneDisplay}</p>

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a
              href={BRAND.instagramUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-ig"
              className="inline-flex items-center gap-2 h-11 px-5 bg-ig-gradient text-white text-[11px] tracking-[0.25em] uppercase hover:brightness-95 transition-all"
            >
              <IgIcon className="h-4 w-4" /> Instagram
            </a>
            <a
              href={BRAND.facebookUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-fb"
              className="inline-flex items-center gap-2 h-11 px-5 bg-fb text-white text-[11px] tracking-[0.25em] uppercase hover:brightness-95 transition-all"
            >
              <FbIcon className="h-4 w-4" /> Facebook
            </a>
            <a
              href={waLink()}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-wa"
              className="inline-flex items-center gap-2 h-11 px-5 bg-[#25D366] text-white text-[11px] tracking-[0.25em] uppercase hover:brightness-95 transition-all"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] tracking-[0.2em] uppercase text-zinc-500">
          <span>
            © {new Date().getFullYear()} Ghisa Ram Khandelwal Saraf. All
            rights reserved.
          </span>
          <span className="text-zinc-600">Pure Silver · Chandni Chowk · Since 1972</span>
        </div>
      </div>
    </footer>
  );
};
